import React from 'react'
import keyBy from 'lodash/keyBy'
import {
  TextField,
  useQuery,
  Datagrid,
  Pagination,
  ListContextProvider,
  FunctionField,
} from 'react-admin'
import { formatDate } from '../../../utils'
import { usePagination } from '../../../../hooks'

export const OrganizerTournamentList = ({ id }) => {
  const { page, perPage, setPage, setPerPage } = usePagination()
  const { data, total } = useQuery({
    type: 'getList',
    resource: `users/${id}/created_tournaments`,
    payload: {
      pagination: { page, perPage },
      sort: { field: 'id', order: 'ASC' },
    },
  })
  return (
    <ListContextProvider
      value={{
        resource: 'created_tournaments',
        basePath: '/users',
        data: keyBy(data, 'id'),
        ids: data?.map((el) => el.id),
        currentSort: { field: 'id', order: 'ASC' },
        selectedIds: [],
      }}
    >
      <Datagrid rowClick={(id) => `/tournaments/${id}`}>
        <TextField source='id' label='ID' />
        <TextField source='sportKind' label='Вид спорта' />
        <TextField source='name' label='Название' />
        <TextField source='owner.fullName' label='Организатор' />
        <TextField source='place' label='Место' emptyText='Не указано' />
        <TextField source='city.name' label='Город' emptyText='Не указано' />
        <TextField source='address' label='Адрес' emptyText='Не указано' />
        <TextField
          source='owner.phone'
          label='Номер телефона'
          emptyText='Не указано'
        />
        <TextField
          source='participantsLimit'
          label='Максимальное кол-во регистраций'
          emptyText='Не указано'
        />
        <FunctionField
          label='Период проведения'
          render={(record) =>
            `C ${formatDate(record.dateStart)} по ${formatDate(record.dateEnd)}`
          }
        />
      </Datagrid>
      <Pagination
        page={page}
        perPage={perPage}
        setPage={setPage}
        total={total}
        setPerPage={setPerPage}
      />
    </ListContextProvider>
  )
}
